const TAGS_PERMITIDAS = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'span'
]);

const TAGS_REMOVER_COMPLETAMENTE = new Set(['script', 'style', 'iframe', 'object', 'embed']);

const CORES_NOMEADAS_PERMITIDAS = new Set([
  'black',
  'white',
  'red',
  'green',
  'blue',
  'yellow',
  'orange',
  'gray',
  'grey',
  'brown',
  'pink',
  'purple',
  'teal',
  'navy'
]);

const temTagHtml = (texto = '') => /<\/?[a-z][\s\S]*>/i.test(texto);

const escaparHtml = (texto = '') =>
  texto
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const normalizarTamanhoFonte = (valor = '') => {
  const match = String(valor).trim().match(/^([0-9]+(?:\.[0-9]+)?)(px|rem|em|%)$/i);
  if (!match) return '';

  const numero = Number(match[1]);
  const unidade = match[2].toLowerCase();

  if (unidade === 'px' && numero >= 10 && numero <= 40) return `${numero}px`;
  if (unidade === 'rem' && numero >= 0.625 && numero <= 2.5) return `${numero}rem`;
  if (unidade === 'em' && numero >= 0.625 && numero <= 2.5) return `${numero}em`;
  if (unidade === '%' && numero >= 70 && numero <= 250) return `${numero}%`;

  return '';
};

const normalizarCor = (valor = '') => {
  const cor = String(valor).trim().toLowerCase();

  const hexOk = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(cor);
  const rgbOk = /^rgba?\((\s*\d{1,3}\s*,){2}\s*\d{1,3}(\s*,\s*(0|0?\.\d+|1))?\s*\)$/i.test(cor);
  const hslOk = /^hsla?\((\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%)(\s*,\s*(0|0?\.\d+|1))?\s*\)$/i.test(cor);

  if (hexOk || rgbOk || hslOk || CORES_NOMEADAS_PERMITIDAS.has(cor)) return cor;
  return '';
};

const sanitizarStyle = (style = '') => {
  const regras = String(style)
    .split(';')
    .map((item) => item.trim())
    .filter(Boolean);

  const estilosPermitidos = [];

  regras.forEach((regra) => {
    const [propRaw, valorRaw] = regra.split(':');
    if (!propRaw || !valorRaw) return;

    const prop = propRaw.trim().toLowerCase();
    const valor = valorRaw.trim();

    if (prop === 'color') {
      const cor = normalizarCor(valor);
      if (cor) estilosPermitidos.push(`color: ${cor}`);
    }

    if (prop === 'font-size') {
      const tamanho = normalizarTamanhoFonte(valor);
      if (tamanho) estilosPermitidos.push(`font-size: ${tamanho}`);
    }
  });

  return estilosPermitidos.join('; ');
};

const limparNo = (no) => {
  if (!no || !no.childNodes) return;

  [...no.childNodes].forEach((filho) => {
    if (filho.nodeType !== 1) {
      return;
    }

    const tag = filho.tagName.toLowerCase();

    if (TAGS_REMOVER_COMPLETAMENTE.has(tag)) {
      filho.remove();
      return;
    }

    if (!TAGS_PERMITIDAS.has(tag)) {
      while (filho.firstChild) {
        no.insertBefore(filho.firstChild, filho);
      }
      filho.remove();
      return;
    }

    [...filho.attributes].forEach((attr) => {
      if (attr.name.toLowerCase() !== 'style') {
        filho.removeAttribute(attr.name);
      }
    });

    if (filho.hasAttribute('style')) {
      const styleLimpo = sanitizarStyle(filho.getAttribute('style'));
      if (styleLimpo) {
        filho.setAttribute('style', styleLimpo);
      } else {
        filho.removeAttribute('style');
      }
    }

    limparNo(filho);
  });
};

const sanitizarHtml = (html = '') => {
  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
    return escaparHtml(html).replace(/\r?\n/g, '<br />');
  }

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
  const raiz = doc.body.firstElementChild;

  limparNo(raiz);

  return raiz.innerHTML;
};

export const formatarDescricaoLonga = (texto = '') => {
  const valor = String(texto ?? '');
  if (!valor.trim()) return '';

  if (temTagHtml(valor)) {
    return sanitizarHtml(valor);
  }

  return escaparHtml(valor).replace(/\r?\n/g, '<br />');
};
